import { render, staticRenderFns } from "./CurrencyTable.vue?vue&type=template&id=30892532&scoped=true&"
import script from "./CurrencyTable.vue?vue&type=script&lang=js&"
export * from "./CurrencyTable.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyTable.vue?vue&type=style&index=0&id=30892532&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30892532",
  null
  
)

export default component.exports